import L from 'leaflet';
import { getScreenshot } from '../features/media/mediaSlice';
import { getTileLayerForSelectedBackground, getTileLayerForUser } from './mappingHelper';
import { saveAs } from 'file-saver';

export const downloadMapImage = (map, user, dispatch, data) => {
    if (!map) return;

    // Get map size and other details
    const mapSize = map.getSize();
    const mapCenter = map.getCenter();
    const tileLayer = data.background ? getTileLayerForSelectedBackground(data.background) : getTileLayerForUser(user);
    const exportQuality = data.exportQuality;

    // Collect polylines and markers data
    const polylines = [];
    const markers = [];

    map.eachLayer(layer => {
        if (layer instanceof L.Polyline) {
            const polyline = layer.toGeoJSON();
            polyline.properties = {
                color: layer.options.color,
                weight: layer.options.weight,
                opacity: layer.options.opacity,
                dashArray: layer.options.dashArray,
            };
            polylines.push(polyline);
        }

        if (layer instanceof L.Marker) {
            if (layer.options.icon.options.iconUrl.includes('map-point-preview'))
                return;

            const marker = layer.toGeoJSON();
            const iconVariant = (layer.options.icon.options.iconUrl.includes('map-point-upcoming')) ? 'upcoming' : 'default';

            marker.properties = {
                iconVariant: iconVariant,
                iconSize: layer.options.icon.options.iconSize,
                iconAnchor: layer.options.icon.options.iconAnchor,
            };
            markers.push(marker);
        }
    });

    // Dispatch action to get screenshot
    dispatch(getScreenshot({
        height: mapSize.y,
        width: mapSize.x,
        enableWatermark: data.enableWatermark,
        exportQuality: exportQuality,
        center: [mapCenter.lat, mapCenter.lng],
        zoom: map.getZoom(),
        tileLayer: tileLayer,
        polylines: JSON.stringify(polylines),
        markers: JSON.stringify(markers),
    }));
};

export const handleDownloadResponse = (data) => {
    if (data) {
        const dateString = new Date().toLocaleDateString('en-GB').split('/').join('-');
        const fileName = `trainlookout-map-${dateString}.png`;

        const base64String = `data:image/png;base64,${data.image}`;
        let arr = base64String.split(',');
        let mime = arr[0].match(/:(.*?);/)[1];
        let bstr = atob(arr[1]);
        let n = bstr.length;
        let uint8Array = new Uint8Array(n);

        while (n--) {
            uint8Array[n] = bstr.charCodeAt(n);
        }

        let file = new File([uint8Array], fileName, { type: mime });
        saveAs(file, fileName);
    }
};
